import { Dictionary } from "lodash"

const exampleFormData = {
  'Full name': 'Carlin',
  Email: 'carlin@theowyesdavid.com',
  'Mobile number': '12167955105',
  'Company name': 'Theo. Wyes David, Ltd.',
  'Net Income (per month)': '10000',
  'State of Residency': 'OH',
  'Goals - Future Events': 'Purchase a house',
  'Desired Areas of Support': 'Debt-Management',
  'Financial Term Familiarity': 'Modern Portfolio Theory',
  'Investment Experience': 'Intermediate',
  'Desired Meeting Timeline': 'Flexible',
  'Desired Meeting Frequency': "I don't know yet",
  'Income - Annual Salary': '140000',
  'Income - Monthly Salary (after taxes)': '9000',
  'Income - Monthly (other sources)': '1000',
  'Assets - Balance - 401k': '0',
  '401k Contribution - Personal': '0',
  'Assets - Balance (all Retirement Accounts excluding 401k)': '14000',
  'Assets - Value - Real Estate (all holdings)': '0',
  'Assets - Balance - (other Investments)': '800',
  'Debt - Balance - Credit Cards': '20000',
  'Debt - Balance - Mortgages': '0',
  'Debt - Balance - Home Equity Loans': '0',
  'Debt - Balance - Student Loans': '0',
  'Debt - Balance - (Other loans)': '15000',
  'Expenses - Monthly - Rent': '1350',
  'Expenses - Monthly - Utilities': '800',
  'Expenses - Monthly - Auto/Transportation': '1500',
  'Expenses - Monthly - Groceries': '100',
  'Expenses - Monthly - Health/Fitness': '150',
  'Expenses - Monthly - Dining Out': '400',
  'Expenses - Monthly - Household Shopping (excluding groceries)': '110',
  'Expenses - Monthly - Internet/Telecommunications': '500',
  'Expenses - Monthly - Traveling': '100',
  'Expenses - Monthly - Personal Shopping': '50',
  'Expenses - Monthly - Subscriptions': '120',
  'Expenses - Monthly - Miscellaneous': '90',
  'Goals - Investment': 'Wealth creation',
  'Date of Birth': '1993-03-03',
  'Comfort Level Managing Finances': 'Very',
  'Comfort Level Investing': 'Somewhat',
  'Personal Savings and Investments Sentiment': 'Could be better',
  'Risk Tolerance Level': 'Medium',
}

type exampleFormData = typeof exampleFormData

export interface FinancialProfileData extends exampleFormData {}

// Define available expense options
export const newExpenseOptions = [
  { id: 'Rent', label: 'Rent/Mortgage' },
  { id: 'Utilities', label: 'Utilities' },
  { id: 'Transport/Auto Payment', label: 'Misc. Auto expenses' },
  { id: 'Car Insurance', label: 'Car Insurance' },
  { id: 'Groceries', label: 'Groceries' },
  { id: 'Fitness/Gym membership', label: 'Gym/Fitness Membership' },
  { id: 'Dining Out', label: 'Dining Out' },
  { id: 'Household items (excluding groceries)', label: 'Household items (excluding groceries)' },
  { id: 'Internet', label: 'Internet' },
  { id: 'Phone', label: 'Phone Bill' },
  { id: 'Streaming Services (Music & Video)', label: 'Streaming Services (Music & Video)' },
  { id: 'Subscriptions', label: 'Subscriptions' },
  { id: 'Personal/Shopping', label: 'Personal/Shopping' },
  // { id: 'Home Insurance', label: 'Renters/Homeowners Insurance' },
  // { id: 'Meal Plan', label: 'Meal Plan' },
  { id: 'Health Insurance', label: 'Health Insurance (If paid outside of paycheck)' },
  { id: 'Life Insurance', label: 'Life Insurance' },
  { id: 'Disability Insurance', label: 'Disability Insurance' },
  { id: 'Property Insurance', label: 'Property Insurance' },
  { id: `Renters's Insurance`, label: `Renters's Insurance` },
  { id: 'Pet Insurance', label: 'Pet Insurance' },
  { id: 'Traveling', label: 'Travel' },
  { id: 'Vehicle Fueling', label: 'Vehicle Fueling' },
  { id: 'Recurring Donations', label: 'Recurring Donations' },
  //   id: 'Misc. Entertainment',
  //   label: 'Misc. Entertainment: Sporting events, Movies, Concerts, etc.',
  // },
  { id: 'Misc Expenses', label: 'Misc Expenses' },
  { id: 'Family/Cultural Support', label: 'Family/Cultural Support' },
  //{ id: 'Car Payment', label: 'Car Payment' },
  // { id: 'Dental Care', label: 'Dental Care' },
  // { id: 'personal_health_maintenance', label: 'Personal Health & Maintenance' },
  // Education: [
  //   { id: 'student_loans', label: 'Student Loans' },
  //   { id: 'Tuition', label: 'Tuition' },
  // ],
  // {
]

// Pronouns options for dropdown
export const pronounsItems = [
  { label: 'He/Him', value: 'He/Him' },
  { label: 'She/Her', value: 'She/Her' },
]

// Pronouns options for dropdown
export const AccountTypes = [
  { label: 'Type 1', value: 'Type 1' },
  { label: 'Type 2', value: 'Type 2' },
]

export const PlaidAccountTypeToZAInputMap = {
  depository: Object.assign(
    {},
    ...['checking', 'money market', 'paypal', 'prepaid', 'cash management', 'ebt'].map((subtype) => ({[subtype]: "Assets - Balance - Checking (other)"})),
    ...['savings', 'hsa', 'cd'].map((subtype) => ({[subtype]: "Assets - Balance - Savings (other)"})),
  ) as Dictionary<string>,
  credit: Object.assign(
    {
      default: 'Debt - Balance - Credit Cards (other)'
    }
  ) as Dictionary<string>,
  loan: Object.assign(
    {
      default: 'Debt - Balance - (Other loans)',
      'home equity': 'Debt - Balance - Home Equity Loans (other)',
      'mortgage': 'Debt - Balance - Mortgages (other)',
      'student': 'Debt - Balance - Student Loans (other)',
      'auto': 'Debt - Balance - Auto Loans (other)',
    }
  ) as Dictionary<string>,
  investment: Object.assign(
    {
      ira: "Assets - Balance - Traditional IRA",
      '401k': "Assets - Balance - Traditional 401k",
      roth: "Assets - Balance - Roth IRA",
      'roth 401k': "Assets - Balance - Roth 401k",
      default: "Assets - Balance - Misc Investment Accounts",
      ...['401a', '403B', '457b', 'keogh', 'retirement', 'sep ira', 'simple ira'].map((subtype) => ({[subtype]: "Assets - Balance - Other Retirement Accounts (excluding 401k/IRA)"})),
    },
  ) as Dictionary<string>,
}

export const PlaidAccountTypes = {
  "depository": {
    "description": "An account type holding cash, in which funds are deposited.",
    "subTypes": [
      {
        "name": "checking",
        "description": "Checking account"
      },
      {
        "name": "savings",
        "description": "Savings account"
      },
      {
        "name": "hsa",
        "description": "Health Savings Account (US only) that can only hold cash"
      },
      {
        "name": "cd",
        "description": "Certificate of deposit account"
      },
      {
        "name": "money market",
        "description": "Money market account"
      },
      {
        "name": "paypal",
        "description": "PayPal depository account"
      },
      {
        "name": "prepaid",
        "description": "Prepaid debit card"
      },
      {
        "name": "cash management",
        "description": "A cash management account, typically a cash account at a brokerage"
      },
      {
        "name": "ebt",
        "description": "An Electronic Benefit Transfer (EBT) account, used by certain public assistance programs to distribute funds (US only)"
      }
    ]
  },
  "credit": {
    "description": "A credit card type account.",
    "subTypes": [
      {
        "name": "credit card",
        "description": "Bank-issued credit card"
      },
      {
        "name": "paypal",
        "description": "PayPal-issued credit card"
      }
    ]
  },
  "loan": {
    "description": "A loan type account.",
    "subTypes": [
      {
        "name": "auto",
        "description": "Auto loan"
      },
      {
        "name": "business",
        "description": "Business loan"
      },
      {
        "name": "commercial",
        "description": "Commercial loan"
      },
      {
        "name": "construction",
        "description": "Construction loan"
      },
      {
        "name": "consumer",
        "description": "Consumer loan"
      },
      {
        "name": "home equity",
        "description": "Home Equity Line of Credit (HELOC)"
      },
      {
        "name": "loan",
        "description": "General loan"
      },
      {
        "name": "mortgage",
        "description": "Mortgage loan"
      },
      {
        "name": "overdraft",
        "description": "Pre-approved overdraft account, usually tied to a checking account"
      },
      {
        "name": "line of credit",
        "description": "Pre-approved line of credit"
      },
      {
        "name": "student",
        "description": "Student loan"
      },
      {
        "name": "student federal",
        "description": "Student loan (federal)"
      },
      {
        "name": "student private",
        "description": "Student loan (private)"
      },
      {
        "name": "buy now pay later",
        "description": "Buy now pay later (BNPL)"
      },
      {
        "name": "other",
        "description": "Other loan type or unknown loan type"
      }
    ]
  },
  "investment": {
    "description": "An investment account.",
    "subTypes": [
      {
        "name": "529",
        "description": "Tax-advantaged college savings and prepaid tuition 529 plans (US)"
      },
      {
        "name": "401a",
        "description": "Employer-sponsored money-purchase 401(a) retirement plan (US)"
      },
      {
        "name": "401k",
        "description": "Standard 401(k) retirement account (US)"
      },
      {
        "name": "403B",
        "description": "403(b) retirement savings account for non-profits and schools (US)"
      },
      {
        "name": "457b",
        "description": "Tax-advantaged deferred-compensation 457(b) retirement plan for governments and non-profits (US)"
      },
      {
        "name": "brokerage",
        "description": "Standard brokerage account"
      },
      {
        "name": "cash isa",
        "description": "Individual Savings Account (ISA) that pays interest tax-free (UK)"
      },
      {
        "name": "crypto exchange",
        "description": "Standard cryptocurrency exchange account"
      },
      {
        "name": "education savings account",
        "description": "Tax-advantaged Coverdell Education Savings Account (ESA) (US)"
      },
      {
        "name": "fixed annuity",
        "description": "Fixed annuity"
      },
      {
        "name": "gic",
        "description": "Guaranteed Investment Certificate (Canada)"
      },
      {
        "name": "health reimbursement arrangement",
        "description": "Tax-advantaged Health Reimbursement Arrangement (HRA) benefit plan (US)"
      },
      {
        "name": "hsa",
        "description": "Non-cash tax-advantaged medical Health Savings Account (HSA) (US)"
      },
      {
        "name": "ira",
        "description": "Traditional Individual Retirement Account (IRA) (US)"
      },
      {
        "name": "isa",
        "description": "Non-cash Individual Savings Account (ISA) (UK)"
      },
      {
        "name": "keogh",
        "description": "Keogh self-employed retirement plan (US)"
      },
      {
        "name": "lif",
        "description": "Life Income Fund (LIF) retirement account (Canada)"
      },
      {
        "name": "life insurance",
        "description": "Life insurance account"
      },
      {
        "name": "lira",
        "description": "Locked-in Retirement Account (LIRA) (Canada)"
      },
      {
        "name": "lrif",
        "description": "Locked-in Retirement Income Fund (LRIF) (Canada)"
      },
      {
        "name": "lrsp",
        "description": "Locked-in Retirement Savings Plan (Canada)"
      },
      {
        "name": "mutual fund",
        "description": "Mutual fund account"
      },
      {
        "name": "non-custodial wallet",
        "description": "A cryptocurrency wallet where the user controls the private key"
      },
      {
        "name": "non-taxable brokerage account",
        "description": "A non-taxable brokerage account that is not covered by a more specific subtype"
      },
      {
        "name": "other",
        "description": "An account whose type could not be determined"
      },
      {
        "name": "other annuity",
        "description": "An annuity account not covered by other subtypes"
      },
      {
        "name": "other insurance",
        "description": "An insurance account not covered by other subtypes"
      },
      {
        "name": "pension",
        "description": "Standard pension account"
      },
      {
        "name": "prif",
        "description": "Prescribed Registered Retirement Income Fund (Canada)"
      },
      {
        "name": "profit sharing plan",
        "description": "Plan that gives employees share of company profits"
      },
      {
        "name": "qshr",
        "description": "Qualifying share account"
      },
      {
        "name": "rdsp",
        "description": "Registered Disability Savings Plan (RSDP) (Canada)"
      },
      {
        "name": "resp",
        "description": "Registered Education Savings Plan (Canada)"
      },
      {
        "name": "retirement",
        "description": "Retirement account not covered by other subtypes"
      },
      {
        "name": "rlif",
        "description": "Restricted Life Income Fund (RLIF) (Canada)"
      },
      {
        "name": "roth",
        "description": "Roth IRA (US)"
      },
      {
        "name": "roth 401k",
        "description": "Employer-sponsored Roth 401(k) plan (US)"
      },
      {
        "name": "rrif",
        "description": "Registered Retirement Income Fund (RRIF) (Canada)"
      },
      {
        "name": "rrsp",
        "description": "Registered Retirement Savings Plan (Canadian, similar to US 401(k))"
      },
      {
        "name": "sarsep",
        "description": "Salary Reduction Simplified Employee Pension Plan (SARSEP), discontinued retirement plan (US)"
      },
      {
        "name": "sep ira",
        "description": "Simplified Employee Pension IRA (SEP IRA), retirement plan for small businesses and self-employed (US)"
      },
      {
        "name": "simple ira",
        "description": "Savings Incentive Match Plan for Employees IRA, retirement plan for small businesses (US)"
      },
      {
        "name": "sipp",
        "description": "Self-Invested Personal Pension (SIPP) (UK)"
      },
      {
        "name": "stock plan",
        "description": "Standard stock plan account"
      },
      {
        "name": "tfsa",
        "description": "Tax-Free Savings Account (TFSA), a retirement plan similar to a Roth IRA (Canada)"
      },
      {
        "name": "trust",
        "description": "Account representing funds or assets held by a trustee for the benefit of a beneficiary. Includes both revocable and irrevocable trusts."
      },
      {
        "name": "ugma",
        "description": "'Uniform Gift to Minors Act' (brokerage account for minors, US)"
      },
      {
        "name": "utma",
        "description": "'Uniform Transfers to Minors Act' (brokerage account for minors, US)"
      },
      {
        "name": "variable annuity",
        "description": "Tax-deferred capital accumulation annuity contract"
      }
    ]
  },
  "other": {
    "description": "Other or unknown account type.",
    "subTypes": []
  }
};

// Employment status options for checkboxes
export const employmentStatusOptions = [
  { label: 'Employed', value: true },
  { label: 'Unemployed', value: false },
]

// Relationship status options for checkboxes
export const relationshipStatusOptions = [
  { label: 'Married', value: true },
  { label: 'Single', value: false },
]

// Options for dependents question
export const confirmationOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
]

// Educational background options for checkboxes
export const educationalBackgroundOptions = [
  { label: 'High School', value: 'High School' },
  { label: 'Some College', value: 'Some College' },
  { label: 'Bachelors', value: 'Bachelors' },
  { label: 'Masters', value: 'Masters' },
  { label: 'Professional Degree (JD, MD, PHD)', value: 'Professional Degree (JD, MD, PHD)' },
  { label: 'Not Applicable', value: 'Not Applicable' },
]

export const employmentType = [
  { label: 'Full-time', value: 'Full-time' },
  { label: 'Part-time', value: 'Part-time' },
  { label: 'Contractor', value: 'Contractor' },
]

//INCOME PAGE
//Income Change Anticipate
export const incomeChange = [
  { label: 'Promotion', value: 'Promotion' },
  { label: 'Demotion', value: 'Demotion' },
  { label: 'Changing Jobs', value: 'Changing Jobs' },
  { label: 'Salary Increase', value: 'Salary Increase' },
  { label: 'Salary Decrease', value: 'Salary Decrease' },
  { label: 'Changing Jobs', value: 'Changing Jobs' },
  { label: 'Add new Job', value: 'Add new Job' },
  { label: 'Separate from a Job', value: 'Separate from a Job' },
  { label: 'Others', value: 'Others' },
]

export const incomeStability = [
  { label: 'Stable', value: 'Stable' },
  { label: 'Unstable', value: 'Unstable' },
]

//Risk And Investment Page
export const investmentLengthOptions = [
  { value: '0-2 years', label: `0-2 years`, description: `We'll focus on preserving your capital with lower-risk investments. While growth potential is limited, this approach protects against the risk of needing to sell during a market downturn.` },
  { value: '2-5 years', label: `2-5 years`, description: `This "middle ground" approach aims to capture some market growth while managing downside risk.` },
  { value: 'More than 5 years', label: `5+ years`, description: `This timeframe allows your investments to potentially benefit from compound growth and recovery from inevitable market corrections.` },
]

export const riskToleranceOptions = [
  { value: '1 (Very Conservative)', label: `1 (Very Conservative)`, description: `Sell everything immediately to prevent further losses - I can't tolerate seeing my account value decline` },
  { value: '2 (Conservative)', label: `2 (Conservative)`, description: `Sell half to protect some principal while keeping some invested` },
  { value: '3 (Moderate)', label: `3 (Moderate)`, description: `Feel uncomfortable but do nothing and wait for recovery` },
  { value: '4 (Aggressive)', label: `4 (Aggressive)`, description: `Stay invested and not add more money` },
  { value: '5 (Very Aggressive)', label: `5 (Very Aggressive)`, description: `View it as a buying opportunity and invest additional funds` },
]

export const climateImpactOptions = [
  { value: '5 (Very Concerned)', label: `5 (Very Concerned)`, description: `I want to actively support climate solutions and clean energy transition` },
  { value: '4 (Concerned)', label: `4 (Concerned)`, description: `I want to avoid fossil fuels and support sustainable companies` },
  { value: '3 (Moderately Concerned)', label: `3 (Moderately Concerned)`, description: `I'm interested if it doesn't significantly compromise returns` },
  { value: '2 (Slightly Concerned)', label: `2 (Slightly Concerned)`, description: `I'm open to considering it` },
  { value: '1 (Not Concerned)', label: `1 (Not Concerned)`, description: `I'm focused primarily on financial returns` },
]

export const investmentAmountOptions = [
  { value: 'Less than $5,000', label: 'Less than $5,000' },
  { value: '$5,000 or more', label: '$5,000 or more' },
]

export const financialAdviceOptions = [
  { label: '1:1 Conversations', value: '1:1 Conversations' },
  { value: 'Group Discussions', label: 'Group Discussions' },
  { value: 'Videos', label: 'Videos' },
  { value: 'Newsletters', label: 'Newsletters' },
  { value: 'Essays', label: 'Essays' },
  { value: 'Books', label: 'Books' },
  { value: 'Podcasts', label: 'Podcasts' },
  { value: 'Other (Please specify)', label: 'Other (Please specify)' },
]

//Financial Security
export const financialSecurityPlanOPtions = [
  { value: 'Estate Plan', label: 'Estate Plan' },
  { value: 'Will', label: 'Will' },
  { value: 'Both', label: 'Both' },
]

export const insurancePoliciesOptions = [
  { value: 'all', label: 'Select All' },
  { value: 'Health Insurance', label: 'Health Insurance' },
  { value: 'Life Insurance', label: 'Life Insurance' },
  { value: 'Disability Insurance', label: 'Disability Insurance' },
  { value: 'Property Insurance', label: 'Property Insurance' },
  { value: 'Renter\'s Insurance', label: 'Renter\'s Insurance' },
  { value: 'Auto Insurance', label: 'Auto Insurance' },
]

export const stepLabels = [
  'Client Info',
  'Income',
  'Expenses',
  'Accounts',
  'Assets',
  'Debts & Liabilities',
  'Credit',
  'Financial Goals',
  'Retirement Planning',
  //'Financial Security',
  'Family and Cultural Considerations',
  'Behavioral and Psychological Factors',
  'Lifestyle and Spending Habits',
  'Risk & Investment',
  'Additional Information'
]

// Page 1: Client Info
const relationshipStatus = [
  { label: 'Single', value: 'Single' },
  { label: 'In a relationship', value: 'In a relationship' },
  { label: 'Married', value: 'Married' },
  { label: 'Domestic partnership', value: 'Domestic partnership' },
  { label: 'Divorced', value: 'Divorced' },
  { label: 'Widowed', value: 'Widowed' },
];

const taxFilingStatus = [
  { label: 'Single', value: 'Single' },
  { label: 'Married Filing Jointly', value: 'Married Filing Jointly' },
  { label: 'Married Filing Separately', value: 'Married Filing Separately' },
  { label: 'Head of Household', value: 'Head of Household' },
  { label: 'Qualifying Surviving Spouse', value: 'Qualifying Surviving Spouse' },
];

const dependentsType = [
  { label: 'No dependents', value: 'No dependents' },
  { label: '1 child', value: '1 child' },
  { label: '2 children', value: '2 children' },
  { label: '3 children', value: '3 children' },
  { label: '4+ children', value: '4+ children' },
  { label: 'Aging parent(s)', value: 'Aging parent(s)' },
  { label: 'Both children and aging parent(s)', value: 'Both children and aging parent(s)' },
];

const employmentTypeExpanded = [
  { label: 'W-2 employee (full-time)', value: 'W-2 employee (full-time)' },
  { label: 'W-2 employee (part-time)', value: 'W-2 employee (part-time)' },
  { label: 'Self-employed / Business owner', value: 'Self-employed / Business owner' },
  { label: 'Freelancer / 1099 contractor', value: 'Freelancer / 1099 contractor' },
  { label: 'Gig worker', value: 'Gig worker' },
  { label: 'Student (part-time work)', value: 'Student (part-time work)' },
  { label: 'Student (no income)', value: 'Student (no income)' },
  { label: 'Retired', value: 'Retired' },
  { label: 'Unemployed', value: 'Unemployed' },
];

// Page 2: Income
const annualGrossIncome = [
  { label: 'Under $30K', value: 'Under $30K' },
  { label: '$30K-$50K', value: '$30K-$50K' },
  { label: '$50K-$75K', value: '$50K-$75K' },
  { label: '$75K-$100K', value: '$75K-$100K' },
  { label: '$100K-$150K', value: '$100K-$150K' },
  { label: '$150K-$200K', value: '$150K-$200K' },
  { label: '$200K-$300K', value: '$200K-$300K' },
  { label: 'Over $300K', value: 'Over $300K' },
];

const additionalIncomeSource = [
  { label: 'W-2 (another employer)', value: 'W-2 (another employer)' },
  { label: '1099 / Self-employment', value: '1099 / Self-employment' },
  { label: 'Rental income', value: 'Rental income' },
  { label: 'Investment income', value: 'Investment income' },
  { label: 'Other', value: 'Other' },
];

// Page 5: Debts & Liabilities
const debtType = [
  { label: 'Credit card(s)', value: 'Credit card(s)' },
  { label: 'Personal loan(s)', value: 'Personal loan(s)' },
  { label: 'Student loans (federal)', value: 'Student loans (federal)' },
  { label: 'Student loans (private)', value: 'Student loans (private)' },
  { label: 'Auto loan', value: 'Auto loan' },
  { label: 'Mortgage', value: 'Mortgage' },
  { label: 'Medical debt', value: 'Medical debt' },
  { label: 'Buy now pay later (BNPL)', value: 'Buy now pay later (BNPL)' },
  { label: 'Business debt', value: 'Business debt' },
  { label: 'Other', value: 'Other' },
];

const federalStudentLoanRepayment = [
  { label: 'Standard (10-year fixed)', value: 'Standard (10-year fixed)' },
  { label: 'Graduated', value: 'Graduated' },
  { label: 'Extended (25-year)', value: 'Extended (25-year)' },
  { label: 'Income-Based Repayment (IBR)', value: 'Income-Based Repayment (IBR)' },
  { label: 'Pay As You Earn (PAYE)', value: 'Pay As You Earn (PAYE)' },
  { label: 'Income-Contingent Repayment (ICR)', value: 'Income-Contingent Repayment (ICR)' },
  { label: 'Repayment Assistance Plan (RAP)', value: 'Repayment Assistance Plan (RAP)' },
  { label: 'Was on SAVE (currently in transition)', value: 'Was on SAVE (currently in transition)' },
  { label: 'Not sure', value: 'Not sure' },
  { label: 'Not applicable (private loans only)', value: 'Not applicable (private loans only)' },
];

// Page 6: Assets
const homeOwnershipStatus = [
  { label: 'Own (with mortgage)', value: 'Own (with mortgage)' },
  { label: 'Own (no mortgage)', value: 'Own (no mortgage)' },
  { label: 'Rent', value: 'Rent' },
  { label: 'Live with family/others (no rent)', value: 'Live with family/others (no rent)' },
  { label: 'Other', value: 'Other' },
];

// Page 8: Financial Goals
const goalTargetDate = [
  { label: 'Within 6 months', value: 'Within 6 months' },
  { label: '6 months-1 year', value: '6 months-1 year' },
  { label: '1-2 years', value: '1-2 years' },
  { label: '2-5 years', value: '2-5 years' },
  { label: '5-10 years', value: '5-10 years' },
  { label: '10+ years', value: '10+ years' },
];

// Page 9: Retirement Planning
const investmentExperience = [
  { label: 'No experience', value: 'No experience' },
  { label: 'Beginner (I know the basics)', value: 'Beginner (I know the basics)' },
  { label: 'Intermediate (I’ve invested for a few years)', value: 'Intermediate (I’ve invested for a few years)' },
  { label: 'Advanced (I actively manage investments)', value: 'Advanced (I actively manage investments)' },
];

const employerMatchFormula = [
  { label: 'Dollar for dollar up to 3%', value: 'Dollar for dollar up to 3%' },
  { label: 'Dollar for dollar up to 4%', value: 'Dollar for dollar up to 4%' },
  { label: 'Dollar for dollar up to 5%', value: 'Dollar for dollar up to 5%' },
  { label: 'Dollar for dollar up to 6%', value: 'Dollar for dollar up to 6%' },
  { label: '50 cents per dollar up to 6%', value: '50 cents per dollar up to 6%' },
  { label: 'Other (text field)', value: 'Other (text field)' },
  { label: 'I’m not sure', value: 'I’m not sure' },
];

const healthInsuranceSource = [
  { label: 'Yes, through employer', value: 'Yes, through employer' },
  { label: 'Yes, through marketplace/ACA', value: 'Yes, through marketplace/ACA' },
  { label: 'Yes, through spouse/parent', value: 'Yes, through spouse/parent' },
  { label: 'Yes, through Medicaid/Medicare', value: 'Yes, through Medicaid/Medicare' },
  { label: 'No', value: 'No' },
];

const lifeInsuranceSource = [
  { label: 'Yes, through employer', value: 'Yes, through employer' },
  { label: 'Yes, private policy', value: 'Yes, private policy' },
  { label: 'Yes, both employer and private', value: 'Yes, both employer and private' },
  { label: 'No', value: 'No' },
  { label: 'Not sure', value: 'Not sure' },
];

const disabilityInsuranceSource = [
  { label: 'Yes, through employer', value: 'Yes, through employer' },
  { label: 'Yes, private policy', value: 'Yes, private policy' },
  { label: 'No', value: 'No' },
  { label: 'Not sure', value: 'Not sure' },
];

const lifeInsuranceCoverageAmount = [
  { label: 'Under $50K', value: 'Under $50K' },
  { label: '$50K-$100K', value: '$50K-$100K' },
  { label: '$100K-$250K', value: '$100K-$250K' },
  { label: '$250K-$500K', value: '$250K-$500K' },
  { label: '$500K-$1M', value: '$500K-$1M' },
  { label: 'Over $1M', value: 'Over $1M' },
];

const disabilityCoveragePercentage = [
  { label: 'About 40-50%', value: 'About 40-50%' },
  { label: 'About 60%', value: 'About 60%' },
  { label: 'About 70%', value: 'About 70%' },
  { label: 'About 80%+', value: 'About 80%+' },
  { label: 'I’m not sure', value: 'I’m not sure' },
];

const estatePlanStatus = [
  { label: 'Yes, up to date (reviewed within 2 years)', value: 'Yes, up to date (reviewed within 2 years)' },
  { label: 'Yes, but outdated', value: 'Yes, but outdated' },
  { label: 'No', value: 'No' },
  { label: 'Not sure', value: 'Not sure' },
];

const beneficiaryDesignationStatus = [
  { label: 'Yes, all accounts', value: 'Yes, all accounts' },
  { label: 'Some accounts', value: 'Some accounts' },
  { label: 'No', value: 'No' },
  { label: 'Not sure', value: 'Not sure' },
];

const primaryBeneficiaries = [
  { label: 'Spouse/partner', value: 'Spouse/partner' },
  { label: 'Children', value: 'Children' },
  { label: 'Parent(s)', value: 'Parent(s)' },
  { label: 'Sibling(s)', value: 'Sibling(s)' },
  { label: 'Trust', value: 'Trust' },
  { label: 'Other', value: 'Other' },
  { label: 'I haven’t designated anyone', value: 'I haven’t designated anyone' },
];

const proxyAndPowerOfAttorney = [
  { label: 'Yes, both', value: 'Yes, both' },
  { label: 'Healthcare proxy only', value: 'Healthcare proxy only' },
  { label: 'Power of attorney only', value: 'Power of attorney only' },
  { label: 'Neither', value: 'Neither' },
  { label: 'Not sure', value: 'Not sure' },
];

const genericYesNoNotSure = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
  { label: 'I’m not sure', value: 'I’m not sure' },
];

// Page 11: Behavioral and Psychological Factors
const pastLifeEvents = [
  { label: 'None', value: 'None' },
  { label: 'Got married', value: 'Got married' },
  { label: 'Got divorced', value: 'Got divorced' },
  { label: 'Had a baby', value: 'Had a baby' },
  { label: 'Adopted a child', value: 'Adopted a child' },
  { label: 'Received an inheritance', value: 'Received an inheritance' },
  { label: 'Changed jobs', value: 'Changed jobs' },
  { label: 'Lost a job', value: 'Lost a job' },
  { label: 'Started a business', value: 'Started a business' },
  { label: 'Bought a home', value: 'Bought a home' },
  { label: 'Sold a home', value: 'Sold a home' },
  { label: 'Major health event', value: 'Major health event' },
  { label: 'Death of a family member', value: 'Death of a family member' },
  { label: 'Retired', value: 'Retired' },
];

const unexpectedMoneyBehavior = [
  { label: 'Save it', value: 'Save it' },
  { label: 'Spend it', value: 'Spend it' },
  { label: 'Pay off debt', value: 'Pay off debt' },
  { label: 'Invest it', value: 'Invest it' },
  { label: 'A mix of saving and spending', value: 'A mix of saving and spending' },
];

// Page 13: Risk & Investment
const monthlyInvestmentCapacity = [
  { label: '$0 (none right now)', value: '$0 (none right now)' },
  { label: 'Under $100', value: 'Under $100' },
  { label: '$100-$300', value: '$100-$300' },
  { label: '$300-$500', value: '$300-$500' },
  { label: '$500-$1,000', value: '$500-$1,000' },
  { label: '$1,000-$2,000', value: '$1,000-$2,000' },
  { label: '$2,000-$5,000', value: '$2,000-$5,000' },
  { label: 'Over $5,000', value: 'Over $5,000' },
];

// Page 14: Additional Information
const professionalRelationships = [
  { label: 'CPA or tax preparer', value: 'CPA or tax preparer' },
  { label: 'Financial advisor or planner', value: 'Financial advisor or planner' },
  { label: 'Attorney (estate planning)', value: 'Attorney (estate planning)' },
  { label: 'Insurance agent or broker', value: 'Insurance agent or broker' },
  { label: 'None of the above', value: 'None of the above' },
];

// MASTER EXPORT OBJECT
export const April2026UpdatedOptions = {
  "Client Info": {
    relationshipStatus,
    taxFilingStatus,
    dependentsType,
    employmentTypeExpanded
  },
  "Income": {
    annualGrossIncome,
    additionalIncomeSource,
    genericYesNo: genericYesNoNotSure.slice(0, 2) // Quick helper for the variable income toggle
  },
  "Debts & Liabilities": {
    debtType,
    federalStudentLoanRepayment,
    genericYesNo: genericYesNoNotSure.slice(0, 2)
  },
  "Assets": {
    homeOwnershipStatus
  },
  "Financial Goals": {
    goalTargetDate
  },
  "Retirement Planning": {
    investmentExperience,
    employerMatchFormula,
    healthInsuranceSource,
    lifeInsuranceSource,
    disabilityInsuranceSource,
    lifeInsuranceCoverageAmount,
    disabilityCoveragePercentage,
    estatePlanStatus,
    beneficiaryDesignationStatus,
    primaryBeneficiaries,
    proxyAndPowerOfAttorney,
    genericYesNoNotSure
  },
  "Behavioral Factors": {
    pastLifeEvents,
    unexpectedMoneyBehavior
  },
  "Risk & Investment": {
    monthlyInvestmentCapacity
  },
  "Additional Information": {
    professionalRelationships
  }
};